import { useContext } from "react";
import { ActivePosition } from "src/types/products";

import Context from "../../context";
import useGetTransferPositions from "../../hooks/useGetTransferPositions";

const useGetPositionsSelected = () => {
	const { state } = useContext(Context);

	const { positions } = useGetTransferPositions();

	const positionsSelected: ActivePosition[] = state.selectedPositions
		.filter((i) => i.shares !== null)
		.map((p) => {
			const oldPosition = positions.find((i) => i.positionId === p.id)!;
			return {
				...oldPosition,
				titles: p.shares ?? oldPosition?.titles
			};
		});

	return {
		positionsSelected
	};
};

export default useGetPositionsSelected;
